<template lang="pug">
  v-menu(bottom right)
    template(v-slot:activator='{ on }')
      v-icon(v-on='on' @click='vibrate()' medium) mdi-dots-vertical
    v-list.pa-0
      v-list-item.pa-2(@click='vibrate();gotoSectionOrders()')
        v-icon.pr-1(small) mdi-format-list-numbered
        v-list-item-title.pa-0 {{section.code}} Orders
      v-list-item.pa-2(v-if="['GA','RM','SS'].includes(selectedUser.role)" @click='vibrate();gotoSectionServices()')
        v-icon.pr-1(small) mdi-format-list-bulleted
        v-list-item-title.pa-0 {{section.code}} Services
      v-list-item.pa-2(v-if="['GA','RM','SS'].includes(selectedUser.role)    " @click='vibrate();gotoSectionReports()')
        v-icon.pr-1(small) mdi-library-books
        v-list-item-title.pa-0 {{section.code}} Reports
</template>

<script>
import { storeMixin } from "../../mixins/storeMixin";
export default {
  name: "section-navigator",
  mixins: [storeMixin],
  props: {
    section: Object
  },
  methods: {
    gotoSectionOrders() {
      this.selectSection(this.section);
      this.$router.push(
        `/restaurants/${this.section._restaurantKey}/sections/${this.section.id}/orders`
      );
    },
    gotoSectionServices(serviceId) {
      this.selectSection(this.section);
      this.$router.push(
        `/restaurants/${this.section._restaurantKey}/sections/${
          this.section.id
        }/services/${serviceId || ""}`
      );
    },
    gotoSectionReports() {
      this.selectSection(this.section);
      this.$router.push({
        name: "sectionReports",
        params: {
          restaurantId: this.section._restaurantKey,
          sectionId: this.section.id
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
</style>